import { useState, useEffect } from "react";

const mobileScreenWidth = 481;
const mobileLandscapeScreenWidth = 769;

function checkIsMobileScreen(width: number, isLandscape: boolean): boolean {
   
    if (isLandscape) {
        return width < mobileLandscapeScreenWidth;
    }

    return width < mobileScreenWidth;
}

export const useIsMobile = (isLandscape = false) => {
    const [isMobileScreen, setIsMobileScreen] = useState(
        checkIsMobileScreen(window.innerWidth, isLandscape)
    );

    useEffect(() => {
        const handleResize = () => {
            setIsMobileScreen(checkIsMobileScreen(window.innerWidth, isLandscape));
        };

        window.addEventListener("resize", handleResize);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return isMobileScreen;
};
